
import * as types from '../../constants/constants';

export const verifyOtp = () => ({
  type: types.VERIFY_OTP,
});

export const verifyOtpSuccess = (payload) => ({
  type: types.VERIFY_OTP_SUCCESS,
  payload
});

export const verifyOtpFailure = (error) => ({
  type: types.VERIFY_OTP_FAILURE,
  payload: error,
});

export const verifyEmail = () => ({
  type: types.VERIFY_EMAIL,
});

export const verifyEmailSuccess = (payload) => ({
  type: types.VERIFY_EMAIL_SUCCESS,
  payload
});

export const verifyEmailFailure = (error) => ({
  type: types.VERIFY_EMAIL_FAILURE,
  payload: error,
});


export const lessonid = () => ({
  type: types.LESSON_ID_REQUEST,
});

export const lessonidSuccess = (payload) => ({
  type: types.LESSON_ID_SUCCESS,
  payload
});

export const lessonidFailure = (error) => ({
  type: types.LESSON_ID_FAILURE,
  payload: error,
});

export const topicid = () => ({
  type: types.TOPIC_ID_REQUEST,
});

export const topicidSuccess = (payload) => ({
  type: types.TOPIC_ID_SUCCESS,
  payload
});

export const topicidFailure = (error) => ({
  type: types.TOPIC_ID_FAILURE,
  payload: error,
});